<template>
  <fragment>
    <v-row dense class="mr-5 ml-5" align="center">
      <v-col v-if="isAdmin" class="pl-4 pb-0">
        <h1>
          <span class="text-h5 font-weight-bold">Olá, </span>
          <span class="text-h5 font-weight-bold">{{ userInfo.nome }}! 👋</span>
        </h1>
      </v-col>
    </v-row>
    <v-row class="mr-5 ml-5">
      <v-col cols="12" sm="12" md="9" v-if="isAdmin">
        <v-row>
          <v-col cols="12" md="6">
            <DashCard
              title="Faturamento do Mês"
              :refreshInfo="'faturamento_mensal'"
              :loading="loadingInvoicing"
              :percent="monthlyInvoincing"
              class="mb-2"
            />
          </v-col>
          <v-col cols="12" md="6">
            <DashCard
              title="Produtores Cadastrados"
              :refreshInfo="'quantidade_lojas'"
              :loading="loadingStoreQuantity"
              :percent="storesPercent"
              :information="{
                titles: ['Total de produtores'],
                values: [$dashboard.quantidade_lojas.qtd_loja_total],
              }"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <DashCard
              title="Pedidos"
              :loading="loadingQuantityOrders"
              :refreshInfo="'quantidade_pedidos'"
              :percent="ordersPercent"
              :information="{
                titles: ['Neste Mês', 'Hoje', 'Últimos 3 meses'],
                values: [
                  $dashboard.quantidade_pedidos.qtd_mes,
                  $dashboard.quantidade_pedidos.qtd_hoje,
                  $dashboard.quantidade_pedidos.totais,
                ],
              }"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DashCard
              title="Eventos Vendidos"
              :refreshInfo="'quantidade_produtos'"
              :loading="loadingProductsQuantity"
              :percent="productsPercent"
              :information="{
                titles: ['Neste Mês', 'Hoje', 'Últimos 3 meses'],
                values: [
                  $dashboard.quantidade_produtos.qtd_mes,
                  $dashboard.quantidade_produtos.qtd_hoje,
                  $dashboard.quantidade_produtos.totais,
                ],
              }"
            />
          </v-col>
          <v-col cols="12" md="4">
            <DashCard
              title="Clientes"
              :refreshInfo="'quantidade_clientes'"
              :loading="loadingClientsQuantity"
              :percent="clientsPercent"
              :information="{
                titles: ['Neste Mês', 'Hoje', 'Últimos 3 meses'],
                values: [
                  $dashboard.quantidade_clientes.qtd_mes,
                  $dashboard.quantidade_clientes.qtd_hoje,
                  $dashboard.quantidade_clientes.totais,
                ],
              }"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col md="3" sm="12" fill-height v-if="isAdmin">
        <DashCard
          title="Top 5 eventos"
          infoCard="Mais vendidos do mês"
          :refreshInfo="'top_produtos_vendidos'"
          list
          :loading="loadingTopProducts"
          :items="$dashboard.top_produtos_vendidos"
        />
      </v-col>
      <v-col cols="12" sm="12" md="12" v-if="isAdmin">
        <v-row>
          <template>
            <v-col fill-height>
              <DashCard
                title="Top 10 produtores que mais venderam no mês"
                fill-height
                :refreshInfo="'top_vendas_lojas'"
                list
                :loading="loadingTopStores"
                :items="$dashboard.top_vendas_lojas"
              />
            </v-col>
            <v-col>
              <DashCard
                title="Dez últimos pedidos"
                table
                :refreshInfo="'ultimos_pedidos'"
                :loading="loadingTenLastOrders"
                :headers="headers"
                :items="$dashboard.ultimos_pedidos"
              />
            </v-col>
          </template>
        </v-row>
      </v-col>
    </v-row>
    <!-- <v-row dense>
      <v-col cols="12" v-if="isAdmin">
        <v-sheet class="pa-3" v-if="loadingTenLastOrders">
          <v-skeleton-loader type="card" class="rounded-xl">
          </v-skeleton-loader>
        </v-sheet>
        <DashCard
          v-else
          title="Dez últimos pedidos"
          table
          :refreshInfo="'ultimos_pedidos'"
          :loading="loadingTenLastOrders"
          :headers="headers"
          :items="$dashboard.ultimos_pedidos"
        />
      </v-col>
    </v-row> -->
    <!-- <DashModal v-if="isOpenModal" :isOpenModal="isOpenModal" /> -->
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatCurrency } from "@/utils";
import displayHelpers from "../mixins/breakpoints.mixins";
import DashCard from "@/components/cards/DashCard.vue";
import DashCardCheckin from "@/components/cards/DashCardCheckin.vue";
import DashModal from "@/components/cards/DashModal.vue";
export default {
  name: "Dashboard",
  mixins: [displayHelpers],
  // eslint-disable-next-line vue/no-unused-components
  components: { DashCard, DashCardCheckin, DashModal },
  data() {
    return {
      formatCurrency,
      headers: [
        {
          text: "Pedido",
          align: "center",
          sortable: false,
          value: "pedido",
        },
        {
          text: "Cliente",
          align: "center",
          sortable: false,
          value: "cliente",
        },
        {
          text: "Data do Pedido",
          align: "center",
          sortable: false,
          value: "data_pedido",
        },
        {
          text: "Valor Total",
          align: "center",
          sortable: false,
          value: "valor_total",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["openModal"]),
  },
  computed: {
    ...mapGetters([
      "dashEvent",
      "dashEventLoading",
      "dashEventHasData",
      "checkinEvent",
      // "isOpenModal",
      "saleTicket",
      "userInfo",
    ]),
    loadingTopProducts() {
      return this.$dashboard.carregando_info_top_produtos;
    },
    loadingTenLastOrders() {
      return this.$dashboard.carregando_info_ultimos_pedidos;
    },
    loadingQuantityOrders() {
      return this.$dashboard.carregando_info_qtd_pedidos;
    },
    loadingTopTenClients() {
      return this.$dashboard.carregando_info_top_clientes;
    },
    loadingTopStores() {
      return this.$dashboard.carregando_info_top_lojas;
    },
    loadingInvoicing() {
      return this.$dashboard.carregando_info_faturamento;
    },
    loadingStoreQuantity() {
      return this.$dashboard.carregando_info_qtd_lojas;
    },
    loadingProductsQuantity() {
      return this.$dashboard.carregando_info_qtd_produtos;
    },
    loadingClientsQuantity() {
      return this.$dashboard.carregando_info_qtd_clientes;
    },
    // loadingSoldToday() {
    //   return value: Math.round(this.$dashEvent.vendidos_hoje);
    // },
    ordersPercent() {
      if (Math.sign(this.$dashboard.quantidade_pedidos.porcentagem) === -1) {
        return {
          value:
            Math.round(this.$dashboard.quantidade_pedidos.porcentagem) + "%",
          class: "negative-percent",
          text: "menor que o mês anterior",
        };
      } else {
        return {
          value:
            Math.round(this.$dashboard.quantidade_pedidos.porcentagem) + "%",
          class: "positive-percent",
          text: "maior que o mês anterior",
        };
      }
    },
    productsPercent() {
      if (Math.sign(this.$dashboard.quantidade_produtos.porcentagem) === -1) {
        return {
          value:
            Math.round(this.$dashboard.quantidade_produtos.porcentagem) + "%",
          class: "negative-percent",
          text: "menor que o mês anterior",
        };
      } else {
        return {
          value:
            Math.round(this.$dashboard.quantidade_produtos.porcentagem) + "%",
          class: "positive-percent",
          text: "maior que o mês anterior",
        };
      }
    },
    clientsPercent() {
      if (Math.sign(this.$dashboard.quantidade_clientes.porcentagem) === -1) {
        return {
          value:
            Math.round(this.$dashboard.quantidade_clientes.porcentagem) + "%",
          class: "negative-percent",
          text: "menor que o mês anterior",
        };
      } else {
        return {
          value:
            Math.round(this.$dashboard.quantidade_clientes.porcentagem) + "%",
          class: "positive-percent",
          text: "maior que o mês anterior",
        };
      }
    },
    storesPercent() {
      if (Math.sign(this.$dashboard.quantidade_lojas.porcentagem) === -1) {
        return {
          value: Math.round(this.$dashboard.quantidade_lojas.porcentagem) + "%",
          class: "negative-percent",
          text: "menor que o mês anterior",
        };
      } else {
        return {
          value: Math.round(this.$dashboard.quantidade_lojas.porcentagem) + "%",
          class: "positive-percent",
          text: "maior que o mês anterior",
        };
      }
    },
    monthlyInvoincing() {
      if (Math.sign(this.$dashboard.faturamento_mensal) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.$dashboard.faturamento_mensal)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.$dashboard.faturamento_mensal)),
          class: "positive-percent",
        };
      }
    },
    totalInvoincing() {
      if (Math.sign(this.dashEvent.faturamento_total) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.faturamento_total)),
          class: "positive-percent",
        };
      }
    },
    middleTicket() {
      if (Math.sign(this.dashEvent.ticket_medio) === -1) {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "negative-percent",
        };
      } else {
        return {
          value: Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(Number.parseFloat(this.dashEvent.ticket_medio)),
          class: "positive-percent",
        };
      }
    },
    TotalSold() {
      const totalSold = Number.parseFloat(this.dashEvent.total_vendido);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(totalSold)
      );

      if (Math.sign(totalSold) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },

    TodaySold() {
      const soldToday = Number.parseFloat(this.dashEvent.vendidos_hoje);
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(soldToday)
      );

      if (Math.sign(soldToday) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },

    Courtesy() {
      const cortesiasTotais = Number.parseFloat(
        this.dashEvent.cortesias_totais
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(cortesiasTotais)
      );

      if (Math.sign(cortesiasTotais) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },

    ingDisponiveis() {
      const disponiveis = Number.parseFloat(
        this.dashEvent.ingressos_disponiveis
      );
      const formattedValue = Intl.NumberFormat("pt-BR").format(
        Math.abs(disponiveis)
      );

      if (Math.sign(disponiveis) === -1) {
        return {
          value: `-${formattedValue}`,
          class: "negative-percent",
        };
      } else {
        return {
          value: formattedValue,
          class: "positive-percent",
        };
      }
    },

    percentSold() {
      if (Math.sign(this.dashEvent.percentual) === -1) {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          value: Math.round(this.dashEvent.percentual) + "%",
          class: "positive-percent",
        };
      }
    },

    percentCheckin() {
      if (Math.sign(this.checkinEvent.percentual_realizados) === -1) {
        return {
          text: "Realizados",
          value: Math.round(this.checkinEvent.percentual_realizados) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          text: "Realizados",
          value: Math.round(this.checkinEvent.percentual_realizados) + "%",
          class: "positive-percent",
        };
      }
    },

    percentCheck() {
      if (Math.sign(this.checkinEvent.percentual_restantes) === -1) {
        return {
          text: "Restantes",
          value: Math.round(this.checkinEvent.percentual_restantes) + "%",
          class: "negative-percent",
        };
      } else {
        return {
          text: "Restantes",
          value: Math.round(this.checkinEvent.percentual_restantes) + "%",
          class: "positive-percent",
        };
      }
    },
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info", true).data.user_type === "admin")
        return true;
      return false;
    },
  },
  mounted() {
    if (
      this.$axios.getCookie("oe_jwt") &&
      this.$axios.getLocal("oe_user_info")
    ) {
      const { user_type, dthr_aceite_termo } =
        this.$axios.getLocal("oe_user_info").data;
      if (dthr_aceite_termo === null && user_type === "loja") {
        this.$termos.getTermosLojista();
      }
      this.$dashboard.getDashInfo();
    }
  },
};
</script>

<style scoped>
.positive-percent {
  color: #572c88;
  font-size: 0.875rem;
}

.negative-percent {
  color: #d70200;
  font-size: 0.875rem;
}

.checkin-percent {
  padding: 10px !important;
}
</style>
